import { render } from "./CardService.vue?vue&type=template&id=ab701f40&scoped=true"
import script from "./CardService.vue?vue&type=script&lang=js"
export * from "./CardService.vue?vue&type=script&lang=js"

import "./CardService.vue?vue&type=style&index=0&id=ab701f40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab701f40"]])

export default __exports__